import { ScenarioType } from '@platform/dashboard/enums/scenario-type.enum';
import { WelcomeScreenTemplateModel } from '@platform/dashboard/models/welcome-screen-template-model.model';

export const welcomeScreenScenariosMap = new Map<ScenarioType, WelcomeScreenTemplateModel[]>([
  [
    ScenarioType.SCENARIO_1,
    [
      {
        title: 'Mortgage <br/> Monitor',
        description: 'We’re now using our 24/7 Mortgage Monitor to track your mortgage and ensure you never spend more than you should.',
      },
      {
        imgDesktop: '/assets/images/wm-desktop-step2.png',
        imgMobile: '/assets/images/wm-mobile-step2.png',

        title: 'Daily<br/> compares',
        mobileTitle: 'Daily compares',
        description: 'It compares your mortgage against 100s of factors and 1,000s of deals daily.',
      },
      {
        imgDesktop: '/assets/images/wm-desktop-step3.png',
        imgMobile: '/assets/images/wm-mobile-step3.png',
        title: 'Get<br /> alerts',
        mobileTitle: 'Get alerts',
        description:
          'If you’re already on the best deal you can get, you’ll know it. Better deal available? We’ll be in touch. Updated property valuations, deal expiry dates, rate changes? All of this, and more.',
      },
      {
        imgDesktop: '/assets/images/wm-desktop-step4.svg',
        imgMobile: '/assets/images/wm-mobile-step4.svg',
        title: 'Your adviser <br /> is a click away',
        mobileTitle: 'Your adviser is a click away',
        description: 'And, if you ever need anything else, your mortgage adviser is just a click away.',
      },
    ],
  ],

  [
    ScenarioType.SCENARIO_2,
    [
      {
        title: 'Mortgage <br/> Monitor',
        description:
          'We’re now tracking mortgage opportunities that match your preferences to find the deal that suits you best. We’ll be in touch with you very soon.',
      },
      {
        imgDesktop: '/assets/images/wm-desktop-step4.svg',
        imgMobile: '/assets/images/wm-mobile-step4.svg',
        title: 'Your adviser <br /> is a click away',
        mobileTitle: 'Your adviser  is a click away',
        description: 'Until then, if there’s anything you need to know, your mortgage adviser is just a click away.',
      },
    ],
  ],

  [
    ScenarioType.SCENARIO_3,
    [
      {
        title: 'Mortgage <br/> Monitor',
        description:
          'We’re now tracking the mortgage deals you’ve indicated you’re interested in. When we’ve found an opportunity that matches your preferences, we’ll be in touch to help you to proceed.',
      },
      {
        imgDesktop: '/assets/images/wm-desktop-step2.svg',
        imgMobile: '/assets/images/wm-mobile-step2.svg',

        title: 'Daily<br/> compares',
        mobileTitle: 'Daily compares',
        description:
          'And once you have a mortgage with us, we’ll continue to monitor it day and night, comparing 100s of factors against 1,000s of deals.',
      },
      {
        imgDesktop: '/assets/images/wm-desktop-step3.png',
        imgMobile: '/assets/images/wm-mobile-step3.png',
        title: 'Get<br /> alerts',
        mobileTitle: 'Get alerts',
        description:
          'If a better deal becomes available, you’ll know about it. Plus, we’ll provide you with regular updates on your property value, deal expiry dates, interest rate changes and more.',
      },
      {
        imgDesktop: '/assets/images/wm-desktop-step4.svg',
        imgMobile: '/assets/images/wm-mobile-step4.svg',
        title: 'Your adviser <br /> is a click away',
        mobileTitle: 'Your adviser is a click away',
        description: 'If you need to speak to us at any time, a mortgage adviser is just a click away.',
      },
    ],
  ],

  [
    ScenarioType.SCENARIO_4, // Landlord scenario
    [
      {
        title: 'My MAB Landlord',
        description: 'Helping you monitor and optimise your property portfolio.',
      },
      {
        imgDesktop: '/assets/images/wm-landlord-desktop-step2.png',
        imgMobile: '/assets/images/wm-landlord-mobile-step2.png',

        title: 'Optimise your <br/> mortgage',
        mobileTitle: 'Optimise your mortgage',
        description: 'Make sure you’re getting the best rates with smart alerts.',
      },
      {
        imgDesktop: '/assets/images/wm-landlord-desktop-step3.png',
        imgMobile: '/assets/images/wm-landlord-mobile-step3.png',
        title: 'Know<br /> your equity',
        mobileTitle: 'Know your equity',
        description: 'Always know the value of your portfolio with automatic property value updates.',
      },
      {
        imgDesktop: '/assets/images/wm-landlord-desktop-step4.png',
        imgMobile: '/assets/images/wm-landlord-mobile-step4.png',
        title: 'Access <br /> expert advice',
        mobileTitle: 'Access expert advice',
        description: 'Our brilliant mortgage advisers are on hand to answer questions or queries about your situation or next steps.',
      },
      {
        imgDesktop: '/assets/images/wm-landlord-desktop-step5.png',
        imgMobile: '/assets/images/wm-landlord-mobile-step5.png',
        title: 'Read our <br /> advice articles',
        mobileTitle: 'Read our advice articles',
        description: 'Articles to help you navigate the challenges of being a landlord.',
      },
    ],
  ],

  [
    ScenarioType.SCENARIO_EXPERIAN, // Landlord scenario
    [
      {
        title: 'Mortgage <br/> Monitor',
        description: 'We’re now using our 24/7 Mortgage Monitor to track your mortgage and ensure you never spend more than you should.',
      },
      {
        imgDesktop: '/assets/images/wm-desktop-step2.png',
        imgMobile: '/assets/images/wm-mobile-step2.png',

        title: 'Daily<br/> comparison',
        mobileTitle: 'Daily comparison',
        description:
          'We scan 1000s of mortgage deals from 90+ lenders every day, so you’ll know if there’s a better deal out there. This does not affect your credit score.',
      },
      {
        imgDesktop: '/assets/images/wm-desktop-step3.png',
        imgMobile: '/assets/images/wm-mobile-step3.png',
        title: 'Get<br /> alerts',
        mobileTitle: 'Get alerts',
        description:
          'If you’re already on the best deal you can get, you’ll know it. Better deal available? We’ll be in touch. Updated property valuations, deal expiry dates, rate changes? All of this, and more.',
      },
      {
        imgDesktop: '/assets/images/wm-desktop-step4.svg',
        imgMobile: '/assets/images/wm-mobile-step4.svg',
        title: 'Expert advice <br /> is a click away',
        mobileTitle: 'Expert advice is a click away',
        description:
          'When you need a new mortgage, we can connect you to a mortgage expert at our trusted broker partner Fluent Money, for help and advice.',
      },
    ],
  ],
]);
